import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as keyboardConstants from '../../constants/keyboardConstants';
import * as trackingDataActions from "../../actions/trackingDataActions";

//eslint-disable-line import/no-named-as-default

class SelectMenuOption extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			onSelectFunc: this.props.onSelectFunc,
			params: this.props.params,
			label: this.props.label,
			activeClass: this.props.activeClass,
			isOpen: this.props.isOpen,
			currentFocus: this.props.currentFocus
		};

		this.onSelect = this.onSelect.bind(this);
		this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		if(this.state.isOpen !== nextProps.isOpen){
			this.setState({isOpen:  nextProps.isOpen});
		}
		if(this.state.currentFocus !== nextProps.currentFocus){
			this.setState({currentFocus: Object.assign({}, nextProps.currentFocus)});
		}
		if(this.state.activeClass !== nextProps.activeClass){
			this.setState({activeClass: Object.assign({}, nextProps.activeClass)});
		}

        if(this.state.params !== nextProps.params){
            this.setState({params: Object.assign({}, nextProps.params)});
        }

        if(this.state.label !== nextProps.label){
            this.setState({label:nextProps.label});
        }
	}


	onSelect() {
		this.state.onSelectFunc(this.state.params);
	}

	setKeyboardAccessibility(event) {
		if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
			event.preventDefault();
			this.onSelect();
		}
	}

	render() {
		return (
			<div className={`option-label ${this.props.params.constant === this.state.currentFocus.constant ? 'active' : ''}`} onClick={this.onSelect} onKeyDown={this.setKeyboardAccessibility} role="link" tabIndex={this.state.isOpen && this.props.params.constant === this.state.currentFocus.constant ? "0" : "-1"} dangerouslySetInnerHTML={{__html: this.state.label}}/>
		);

	}
}


SelectMenuOption.propTypes = {
	onSelectFunc: PropTypes.func,
	params: PropTypes.object.isRequired,
	label: PropTypes.string,
	activeClass: PropTypes.string,
	isOpen: PropTypes.bool,
	currentFocus: PropTypes.object,

};


SelectMenuOption.contextTypes = {
	router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
	return {
		contentData: state.contentData,
		userData: state.userData
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(Object.assign({}, trackingDataActions), dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectMenuOption);



/** WEBPACK FOOTER **
 ** ./src/components/form/SelectMenuOption.js
 **/